import { render, staticRenderFns } from "./footerBtn.vue?vue&type=template&id=6b28c8e2&scoped=true"
import script from "./footerBtn.vue?vue&type=script&lang=js"
export * from "./footerBtn.vue?vue&type=script&lang=js"
import style0 from "./footerBtn.vue?vue&type=style&index=0&id=6b28c8e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28c8e2",
  null
  
)

export default component.exports